import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from "../../environments/environment";
import {Shipment} from "../shipment/models/shipment";

@Injectable({
    providedIn: 'root'
})
export class AiSummaryService {

    private apiUrl = `${environment.aiServiceApiUrl}summary`;

    constructor(private http: HttpClient) {
    }

    getShipmentSummary(orderQuery: Shipment): Observable<string> {
        return this.http.post<string>(this.apiUrl + '/shipment', orderQuery, {
            responseType: 'text' as 'json'
        });
    }
}
